import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import Ad from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTitle from '../../../components/newsTitle';
import NewsList from '../../../components/newsList';
import Promote from '../../../components/promote';

class LeftNewsBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: {
                financeTitle,
                financeList0,
                shopInFinance,
                financeList1,
                financeListAd,
                financeHardAd,
                promoteInFinance,
            },
        } = this.props;

        return (
            <div className={styles.left_box}>
                <Chip id="200139" type="struct" title="财经标题" groupName="财经" content={financeTitle}>
                    <NewsTitle size="middle" />
                </Chip>
                <Chip
                    id="195853"
                    type="recommend"
                    title="财经列表1"
                    groupName="财经"
                    content={financeList0}
                    translate="handleNewsData">
                    <NewsList hasTitleImg size="long" />
                </Chip>
                <Chip
                    id="195860"
                    type="recommend"
                    title="财经区电商"
                    groupName="财经"
                    content={shopInFinance}
                    translate="handleNewsData">
                    <NewsList size="long" />
                </Chip>
                <Chip
                    id="225741"
                    type="recommend"
                    title="财经列表2"
                    groupName="财经"
                    content={financeList1}
                    translate="handleNewsData">
                    <NewsList size="long" ad={financeListAd} />
                </Chip>
                <NoSSR>
                    <Ad content={financeHardAd} styleName={styles.dbox} />
                </NoSSR>
                {promoteInFinance && (
                    <Chip id="230192" type="struct" title="铺底推广" groupName="财经" content={promoteInFinance}>
                        <Promote />
                    </Chip>
                )}
            </div>
        );
    }
}

export default errorBoundary(LeftNewsBox);
